export default {
  state: {
    showReportDialog: false,
    showResponseDialog: false,
    sendCorrectionsDialog: false,
    forgotPasswordDialog: false,
  },
  mutations: {
    updateShowReportDialog(state, dialog) {
      state.showReportDialog = dialog;
    },

    updateShowResponseDialog(state, dialog) {
      state.showResponseDialog = dialog;
    },

    updateSendCorrectionsDialog(state, dialog) {
      state.sendCorrectionsDialog = dialog;
    },

    updateForgotPasswordDialog(state, dialog) {
      state.forgotPasswordDialog = dialog;
    },
  },
};
